import { effectiveVideoGenerationProvider } from "@/lib/provider-labels"

/** Mirrors It2tv::ModelConstants::WAN3_VIDEO_MODEL_PREFIXES / wan3_video_model? */
export const WAN3_VIDEO_MODEL_PREFIXES = ["wan3.", "wan3-"] as const

export function isWan3VideoModel(modelId: string | null | undefined): boolean {
  const id = modelId?.trim() ?? ""
  return WAN3_VIDEO_MODEL_PREFIXES.some((prefix) => id.startsWith(prefix))
}

/** Wan multi-shot checkbox: Wan 2.x only, not Wan 3. */
export function wanSupportsMultiShot(project: {
  effective_video_generation_provider?: string | null
  video_generation_provider?: string | null
  effective_video_model?: string | null
}): boolean {
  return effectiveVideoGenerationProvider(project) === "wan" && !isWan3VideoModel(project.effective_video_model)
}
